<template>
  <div class="bigBox">
    <div class="boxSon">
      <!--<header>-->
      <!--<span></span><p><b>【张三】</b>意见反馈获得10积分</p>-->
      <!--</header>-->
      <article>
        <div class="wrap1">
          <span class="word5">*</span>
          <span class="word6">请选择你要举报的类型</span>
        </div>
        <ul class="evalTags">
          <li v-for="(item, index) of evalTags" :class="{evalTagsBoy: index == evalTagsBoy}" :key="index" @click="evalTagsMeth($event, index)">{{item.tags}}</li>
        </ul>
      </article>
      <article>
        <div class="wrap1">
          <span class="word5">*</span>
          <span class="word6">举报描述</span>
        </div>
        <textarea v-model="textinput" name="" id="afterEval" @blur="input_blur" placeholder="提供更多信息，有助于举报被快速处理~"></textarea>
        <p>{{textNum}}/40</p>
      </article>
      <article>
        <div class="wrap1">
          <span class="word5">*</span>
          <span class="word6">图片证据</span>
        </div>
        <div class="evalPhotoBox">
          <!--<ul class="evalPhoto">-->
          <!--<li><img src="../../assets/images/add.png"></li>-->
          <!--</ul>-->
          <van-uploader v-model="fileList"
                        :max-count="3"
                        preview-size="1.04rem"
          />
          <span>最多3张</span>
        </div>
      </article>
    </div>
    <footer :class="{'graybtn': btnControl}">
      <button class="submit" @click="submit">提交</button>
    </footer>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import { Popup } from 'vant'

Vue.use(Popup)
export default {
  name: 'communityReport',
  data () {
    return {
      evalTags: [
        {tags: '广告内容'},
        {tags: '搬运抄袭'},
        {tags: '不友善'},
        {tags: '造谣'},
        {tags: '色情低俗'},
        {tags: '违法违规'},
        {tags: '侵权投诉'},
        {tags: '其他'}
      ],
      evalTagsBoy: 0,
      textinput: '',
      textNum: 0,
      fileList: [],
      fileLen: null,
      imgpath: [],
      fileListWx: [],
      btnControl: false
    }
  },
  mounted: function () {
    if (isWeixin()) fenxiang({path: 'communityreport'})
    // this.getCodeImg()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    textinput (n) {
      if (n.length > 40) {
        this.textNum = 40
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 40)
      console.log(n.length)
    }
  },
  methods: {
    initData () {
      Object.assign(this.$data, this.$options.data())
    },
    afterRead (file, fn) {
      console.log(file)
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      const url = this.ossUrl
      var that = this
      customRequestAjax(url).then(async res => {
        if (res.data.code === 200) {
          const {
            accessid,
            host,
            policy,
            signature,
            dir
          } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + '.png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then(res => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.ossImgUrl + `${dir}${str}`
              var img = `${dir}${str}`.replace('Uploads/', '')
              that.imgpath.push(img)
              that.fileLen++
              if (that.fileLen >= that.fileList.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              } else {
                that.afterRead(that.fileList[that.fileLen], function () {
                  that.submitAxios()
                })
              }
            }
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    evalTagsMeth: function (e, idx) {
      console.log(e)
      this.evalTagsBoy = idx
    },
    submit: function () {
      if (this.textinput.replace(/\s+/g, '').length <= 0) {
        this.$toast('请填写你的意见')
        return
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.imgpath = []
      var that = this
      if (that.fileLen < that.fileList.length) {
        that.afterRead(that.fileList[that.fileLen], function () {
          that.submitAxios()
        })
      } else {
        that.submitAxios()
      }
    },
    submitAxios () {
      var url = 'Wxmall/CommunityPosts/report'
      var that = this
      this.$ckeckgraphic({
        content: that.textinput,
        images: that.imgpath.length > 0 ? that.imgpath.join() : '',
        callback: () => {
          var data = {
            type: that.evalTags[that.evalTagsBoy],
            content: that.textinput,
            images: JSON.stringify(that.imgpath),
            itemid: that.$route.query.id,
            reporttype: that.$route.query.reporttype
          }
          if (!that.btnControl) {
            that.btnControl = true
            customRequestAjax.post(url, data).then(function (res) {
              if (res.data.code === 200) {
                that.initData()
                that.$toast({
                  message: '提交成功',
                  icon: require('../../assets/images/succ.png')
                })
                setTimeout(function () {
                  that.$router.go(-1)
                }, 500)
              } else {
                that.btnControl = false
              }
            })
          } else {
            that.$toast('请勿重复提交')
          }
        }
      })
    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange () {
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      // var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.textinput.match(reg)) {
        this.textinput = this.textinput.replace(reg, '')
      }
      this.textinput = this.textinput.replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
  .bigBox {
    transform: translateZ(0);
    min-height: 100%;
    display:flex;
    flex-direction: column;
    .boxSon {
      flex: 1;
      border-top: 0.1rem solid #EEEEEE;
    }
  }
  header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 0.34rem;
    background: #fff;
    margin: 0.1rem 0.11rem;
    border-radius: 0.04rem;
    padding-left: 0.1rem;
    span{
      background: url("../../assets/images/tags1.png") no-repeat left top;
      background-size: 100% 100%;
      display: block;
      width: 0.47rem;
      height: 0.16rem;
      line-height: 0.16rem;
      text-align: center;
      font-size: 0.08rem;
    }
    p {
      font-size: 0.13rem;
      color: #333333;
    }
    b {
      color: #333;
      font-size: 0.13rem;
      border-left: 0.01rem solid #B8B8B8;
      margin-left: 0.08rem;
      padding-left: 0.08rem;
    }
    font-size: 0.14rem;
  }
  article{
    background: #fff;
    margin: 0 0.11rem;
    padding: 0.15rem 0.11rem;
    border-radius: 0.04rem;
    border-bottom: 0.1rem solid #EEEEEE;
    position: relative;
    .wrap1 {
      font-size: 0.16rem;
      margin-bottom: 0.1rem;
      .word5 {
        font-size: 0.16rem;
        color: rgba(252, 3, 36, 1);
        line-height: 0.22rem;
      }
      .word6 {
        font-size: 0.16rem;
        color: rgba(41, 41, 41, 1);
        line-height: 0.22rem;
      }
    }
    .evalTags {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 0.7rem;
        height: 0.27rem;
        text-align: center;
        color: #262626;
        font-size: 0.12rem;
        border: 0.01rem solid #606060;
        border-radius: 0.14rem;
        margin-right: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.1rem;
        &:last-of-type{
          margin-right: 0;
        }
        &.evalTagsBoy {
          border: 0.01rem solid #FC0324;
          color: #FC0324;
        }
      }
    }
    #afterEval {
      display: block;
      width: 100%;
      min-height: 0.42rem;
      border: none;
      outline: none;
      line-height: 0.18rem;
      font-size: 0.13rem;
      color: #333;
      &::placeholder {
        font-size: 0.13rem;
        color: #999999;
        line-height: 0.18rem;
      }
    }
    p {
      font-size: 0.15rem;
      color: #B0B0B0;
      text-align: right;
      position: absolute;
      right: 0.1rem;
      top: 0.15rem;
    }
    .evalPhotoBox {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      span {
        display: block;
        font-size: 0.15rem;
        color: #B0B0B0;
        margin-left: 0.02rem;
        margin-bottom: 0.08rem;
        position: absolute;
        right: 0.1rem;
        top: 0.15rem;
      }
    }
  }
  footer {
    height: 0.45rem;
    background: #FC0324;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    &.graybtn {
      background: #ccc;
    }
    .prompt {
      font-size: 0.11rem;
      border-radius: 0.04rem;
      color: #5A5A5A;
      text-align: center;
      background: #fff;
      height: 0.48rem;
      padding: 0.08rem 0.24rem 0;
      position: absolute;
      top: -0.58rem;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      -o-transform: translateX(-50%);
      transform: translateX(-50%);
    }
    img {
      width: 0.12rem;
      height: 0.1rem;
      margin: -0.1rem auto 0;
    }
    .submit {
      width: 100%;
      display: block;
      margin: 0 auto;
      line-height: 0.45rem;
      background: none;
      border: none;
      outline: none;
      color: #fff;
      font-size: 0.13rem;
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right:0.17rem;
    bottom:0.8rem;
    width:0.4rem;
    height:0.4rem;
    border-radius: 50%;
    background:rgba(255,255,255,1);
    box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -webkit-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -moz-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -ms-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -o-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      display: block;
    }
    p {
      font-size: 0.09rem;
      color: #444444;
      line-height:0.13rem;
    }
  }
</style>
<style lang="scss">
  .bigBox {
    .van-icon {
      font-size: 0.3rem !important;
      color: #9E9E9E;
    }
    .van-uploader__preview {
      .van-icon {
        font-size: 0 !important;
      }
      margin: 0 0.05rem 0.05rem 0 !important;
    }
    .van-uploader__preview-delete {
      display: block !important;
      top: 0 !important;
      right: 0 !important;
      bottom: auto !important;
      background: transparent !important;
    }
    .van-uploader__preview-delete:before {
      display: block !important;
      content: '' !important;
      width: 0.15rem !important;
      height: 0.13rem !important;
      background: url(../../assets/images/delete2.png) no-repeat left bottom !important;
      background-size: 0.15rem 0.13rem !important;
    }
    .van-uploader__upload,.van-uploader__preview {
      overflow: hidden !important;
      border-radius: 0.03rem !important;
    }
    .van-uploader__upload {
      border: 0.01rem dashed #979797;
    }
    .van-icon__image {
      width: 0.36rem;
      height: 0.36rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/communityReport.vue